<template>
  <div>
    <h1>Happy 4 Years Mo!</h1>
    <p>
      Hey Mo, I made this page as a fun lil easter egg 4 u. Looking forward to
      having a fun time w/ you.
    </p>
    <div id="photos">
      <photo-frame v-for="(memory, index) in memories"
        :key="index" :src="memory.url" :text="memory.description"/>
    </div>
    <h2>I love you through it all,</h2>
    <h2>B.</h2>
    <br>
    <br>
  </div>
</template>

<script>
    import PhotoFrame from '@/components/PhotoFrame'

    export default {
        name: "Mo",
        components: {
          PhotoFrame,      
        },
        data () {
            return {
              memories: [
                {
                  description: "Through birthday fun!",
                  url: this.getImageUrl("bmo_bday.jpeg")
                },
                {
                  description: "Through fluffy face licks!",
                  url: this.getImageUrl("bmo_facelick.jpeg")
                },
                {
                  description: "With long hair!",
                  url: this.getImageUrl("bmo_longhair.JPG")
                },
                {
                  description: "With short hair!",
                  url: this.getImageUrl("bmo_shades.jpeg")
                },
                {
                  description: "At weddings!",
                  url: this.getImageUrl("bmo_wedding.jpeg")
                },
                {
                  description: "Through bittersweet times with friends!",
                  url: this.getImageUrl("bmo_friends.jpeg")
                },
                {
                  description: "Through cold hikes!",
                  url: this.getImageUrl("bmo_hike.jpeg")
                }
              ]
            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style scped lang="scss">
  #photos {
    margin: auto;
    max-width: min(100%, 500px);
  }
</style>
